import { XIcon } from '@phosphor-icons/react'
import React from 'react'

import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'

import { AlertTypeToIconMap } from './alert.constants'
import * as S from './alert.styled'
import { AlertProps } from './alert.types'

export const Alert = ({
  type,
  title,
  message = '',
  className = '',
  iconSize = '2.4rem',
  // NOTE: `closeable` defaults `undefined` intentionally to simply control when only `onClose` is passed
  closeable = undefined,
  onClose,
}: AlertProps) => {
  const isCloseable = closeable === undefined ? !!onClose : closeable

  const TypeIcon = AlertTypeToIconMap[type]

  return (
    <S.Container className={className} $type={type} data-component-id="Alert">
      <Icon icon={TypeIcon} size={iconSize} />
      {(!!title || !!message) && (
        <S.ContentWrapper>
          {title && <S.Title>{title}</S.Title>}
          {message && <S.Message>{message}</S.Message>}
        </S.ContentWrapper>
      )}
      {isCloseable && onClose && (
        <Button onlyBox className="alertCloseBtn" use="unset" size="unset" onClick={onClose}>
          <Icon icon={XIcon} size="2.4rem" />
        </Button>
      )}
    </S.Container>
  )
}
